// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1Oo7-","title":"AfterFrontImage_title__2-HV9"};